import React, { useState } from 'react'
import { Answer, CommonQuestionsContent, FaqsContainer, MoreInfosContainer, Question, QuestionIcon, Text, TextAnswer } from './styled'

export default function CommonQuestions({ items }) {
  const [activeQuestions, setActiveQuestions] = useState([])

  const handleQuestionClick = (id) => {
    if (activeQuestions.includes(id)) {
      setActiveQuestions(activeQuestions.filter(questionId => questionId !== id))
    } else {
      setActiveQuestions([...activeQuestions, id])
    }
  }

  return (
    <>
      <MoreInfosContainer>
        <CommonQuestionsContent faq>
          {
            items?.map((item, index) => {
              const questionId = item?.id || `faq-item-${index}`

              return (
              <FaqsContainer key={questionId}>
                <Question faq onClick={() => handleQuestionClick(questionId)} open={activeQuestions.includes(questionId)}>
                  <Text faq>{item.question}</Text>
                  <QuestionIcon faq open={activeQuestions.includes(questionId)} />
                </Question>
                {
                  activeQuestions.includes(questionId) && (
                    <Answer faq>
                      <TextAnswer faq
                        dangerouslySetInnerHTML={{ __html: String(item?.answer || '').replace(/\n/g, '<br />') }}
                      />
                    </Answer>
                  )
                }
              </FaqsContainer>

            )})
          }
        </CommonQuestionsContent>
      </MoreInfosContainer>
    </>
  )
}
